interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors enabled:hover:border-accent-400 enabled:hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 min-w-9 rounded-md px-3 text-sm font-medium transition-colors cursor-pointer ${
            page === current
              ? "bg-accent-500 text-background-950"
              : "border border-background-700 text-foreground-300 hover:border-accent-400 hover:text-accent-400"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-700 px-3 text-sm text-foreground-200 transition-colors enabled:hover:border-accent-400 enabled:hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}